// 功能访问分析

import UltMeta, { Meta } from "./UltMeta/index";

// 客户端类型

class ClientType extends UltMeta {
    PC = new Meta(1, "PC端");
    APP = new Meta(2, "移动端");
    MINI_PROGRAM = new Meta(3, "移动端");
    H5 = new Meta(4, "移动端");
}

export const CLIENT_TYPE = new ClientType();
